import { PhotoItemEntity } from './photoItemEntity';
import { CreateDatetime } from './valueObjects/createDatetime';
import { LastModifiedDatetime } from './valueObjects/lastModifiedDatetime';
import { MemberId } from './valueObjects/memberId';
import { NurseryId } from './valueObjects/nurseryId';
import { PhotoItemId } from './valueObjects/photoItemId';
import { PhotoItemName } from './valueObjects/photoItemName';
import { PhotoItemPrice } from './valueObjects/photoItemPrice';

import type { PhotoItemProps } from './photoItemEntity';
import type { PhotoItemJson } from '@/types/domain/photo/entities/photoItemEntity';

import { Factory } from '@/domain/factory';

export class PhotoItemFactory extends Factory<
  PhotoItemEntity,
  PhotoItemProps,
  PhotoItemJson
> {
  comparePvt = (a: PhotoItemJson, b: PhotoItemJson) => {
    const da = new Date(a.lastModifiedDatetime);
    const db = new Date(b.lastModifiedDatetime);
    return da < db ? 1 : -1;
  };

  createPvt(props: PhotoItemProps): PhotoItemEntity {
    return new PhotoItemEntity(props, null);
  }

  createFromJsonPvt(props: PhotoItemJson): PhotoItemEntity {
    return this.createPvt({
      photoItemId: PhotoItemId.create(props.photoItemId),
      name: PhotoItemName.create(props.name),
      price: PhotoItemPrice.create(props.price),
      nurseryId: NurseryId.create(props.nurseryId),
      createDatetime: CreateDatetime.create(new Date(props.createDatetime)),
      createMemberId: MemberId.create(props.createMemberId),
      lastModifiedDatetime: LastModifiedDatetime.create(new Date(props.lastModifiedDatetime)),
      lastModifiedMemberId: MemberId.create(props.lastModifiedMemberId),
    });
  }
}
